import React, { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { LoadingOutlined } from "@ant-design/icons";
import { Divider, Spin } from "antd";
import { LogoIcon } from "assets/icons";
import { STORAGE_KEYS } from "constants/appConstant";
import { doVerifyAccount } from "stores/slices/user";
import StorageHelper from "utils/storeHelper";

import VerifyAccountForm from "components/forms/verifyAccountForm";

import { clearAuthData } from "../stores/slices/auth";

import SocialLogin from "./socialLogin";

import styles from "./styles.module.scss";

const VerifyAccountPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  // Get id and type from the search parameters
  const params = useLocation();
  const searchParams = params.search.split("?");
  const searchIdParam = new URLSearchParams(searchParams[1]).get("id");
  const searchTypeParam = new URLSearchParams(searchParams[2]).get("type");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(clearAuthData());
    StorageHelper.removeCookie(STORAGE_KEYS.token);
  }, []);

  const handleSubmit = async values => {
    setLoading(true);
    const { payload } = await dispatch(
      doVerifyAccount({ ...values, id: searchIdParam })
    );

    if (payload && payload.status === 200) {
      // StorageHelper.setCookie(STORAGE_KEYS.token, payload.data.authToken, {
      //   maxAge: payload.data.expireTime,
      // });
      // await dispatch(getMe());
      // setLoading(false);
      // navigate("/admin/dashboard");
      navigate("/auth/sign-in");
      toast.success(
        searchTypeParam === "invite"
          ? t("toast.inviteUserSuccess")
          : t("toast.verifySuccess")
      );
    } else {
      setLoading(false);
      navigate("/auth/sign-in");
    }
  };

  const handleVerifyAccount = async () => {
    if (searchIdParam) {
      const request = { id: searchIdParam };
      const result = await dispatch(doVerifyAccount(request));
      if (result && result?.payload?.status === 200) {
        // if (searchTypeParam === "invite") {
        //   StorageHelper.setCookie(
        //     STORAGE_KEYS.token,
        //     result?.payload?.data?.authToken,
        //     {
        //       maxAge: result?.payload?.data?.expireTime,
        //     }
        //   );
        //   await dispatch(getMe());
        //   navigate("/admin/dashboard");
        //   toast.success(t("toast.inviteUserSuccess"));
        // } else {
        //   navigate("/auth/sign-in");
        // }
        navigate("/auth/sign-in");
        toast.success(
          searchTypeParam === "invite"
            ? t("toast.inviteUserSuccess")
            : t("toast.verifySuccess")
        );
      } else {
        navigate("/auth/sign-in");
      }
    }
  };

  useEffect(() => {
    if (searchTypeParam === "verify" || searchTypeParam === "invite") {
      handleVerifyAccount();
    }
  }, []);

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 32,
      }}
      spin
    />
  );

  return (
    <div className={styles.authPage}>
      <div className={styles.authContent}>
        <div className={styles.authLogo}>
          <LogoIcon />
        </div>
        {searchTypeParam === "verify" && (
          <div
            style={{
              marginTop: 30,
            }}
          >
            <Spin indicator={antIcon} size="large" tip="Verifying...">
              <div className="content" />
            </Spin>
          </div>
        )}
        {searchTypeParam === "invite" && (
          <div
            style={{
              marginTop: 30,
            }}
          >
            <Spin indicator={antIcon} size="large" tip="Inviting...">
              <div className="content" />
            </Spin>
          </div>
        )}

        {searchTypeParam === "password" && (
          <div>
            <div style={{ textAlign: "center" }}>
              <h1>{t("label.createAccount")}</h1>
              <span>{t("text.createAccountMsg")}</span>
            </div>
            <div className={styles.authForm}>
              <VerifyAccountForm onSubmit={handleSubmit} />
              <Divider>
                <span style={{ color: "#9499A0" }}>OR</span>
              </Divider>
              <SocialLogin loading={loading} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyAccountPage;
